import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Thumbnail, Glyphicon } from 'reaxl';

/**
 *  The UserIcon component takes in the isLoggedIn and thumbnailUrl props and if present will  render a Thumbnail component.
 *  Otherwise, it will render a user Glyphicon
 *
 */
function UserIcon(_ref) {
  let {
    isLoggedIn,
    thumbnailUrl,
    className,
    ...rest
  } = _ref;
  if (isLoggedIn && thumbnailUrl) {
    return /*#__PURE__*/_jsx(Thumbnail, {
      src: thumbnailUrl,
      className: "profile-pic display-inline-block"
    });
  }
  return /*#__PURE__*/React.createElement(Glyphicon, Object.assign({
    className: clsx('text-size-500', className),
    glyph: isLoggedIn ? 'user-circle-solid' : 'user-circle-regular'
  }, rest));
}
export default UserIcon;